module.exports = __webpack_public_path__ + "static/media/Rohan2.f9bfa1b6.jpeg";